import baseManagement from '@/assets/base_management.svg';
import businessInfo from '@/assets/business_info.svg';
import businessManagement from '@/assets/business_management.jpg';
import carrierPlatform from '@/assets/carrier_platform.svg';
import companyManagement from '@/assets/company_management.png';
import { Fetch } from '@/lib/fetch';
import Icon from '@ant-design/icons';
import { logs } from '@shoppykey/tools';
import { history } from '@umijs/max';
import { HeaderTitle } from './components/header-title';
import { RightContent } from './components/right-content';
import { setCompanyId, setSysRoleId } from './lib/token';
import { GlobalData } from './schema/global-data';

const ignorePathList = ['/auth/login'];
const CarrierPlatformIcon = () => <img src={carrierPlatform} style={{ width: 14, height: 14 }} />;
const BaseManagementIcon = () => <img src={baseManagement} style={{ width: 14, height: 14 }} />;
const CompanyManagementIcon = () => <img src={companyManagement} style={{ width: 14, height: 14 }} />;
const BusinessManagementIcon = () => <img src={businessManagement} style={{ width: 14, height: 14 }} />;
const BusinessInfoIcon = () => <img src={businessInfo} style={{ width: 14, height: 14 }} />;

export async function getInitialState(): Promise<GlobalData | undefined> {
  if (ignorePathList.includes(history.location.pathname)) {
    return undefined;
  }
  try {
    const currentUser = await Fetch.get<Record<string, any>>('/api/sysOps/user/current/v1');
    setSysRoleId(currentUser.companyRoleId);
    setCompanyId(currentUser.companyId);
    return {
      ...currentUser,
    };
  } catch (error) {
    logs.error(error);
    return undefined;
  }
}

export const layout = () => {
  return {
    rightContentRender: () => <RightContent />,
    menu: {
      locale: false,
    },
    fixSiderbar: true,
    layout: 'mix',
    splitMenus: true,
    contentWidth: 'Fluid',
    fixedHeader: false,
    token: {
      pageContainer: {
        marginInlinePageContainerContent: 24,
      },
      sider: {
        colorMenuBackground: '#fff',
        colorMenuItemDivider: '#dfdfdf',
        colorTextMenu: '#595959',
      },
    },
    logo: false,
    headerTitleRender: (logo: any, title: string) => <HeaderTitle title={title} />,
    menuDataRender: (menuData: any[]) => {
      return menuData.map((item) => {
        switch (item.name) {
          case '基础管理':
            return {
              ...item,
              icon: <Icon component={BaseManagementIcon} />,
            };
          case '资源中心': {
            const children = item.children.map((child: any) => {
              if (child.name === '企业管理') {
                return {
                  ...child,
                  icon: <Icon component={CompanyManagementIcon} />,
                };
              }
              return child;
            });
            return {
              ...item,
              children,
              icon: <Icon component={BusinessManagementIcon} />,
            };
          }
          case '业务管理': {
            const children = item.children.map((child: any) => {
              if (child.name === '业务信息') {
                return {
                  ...child,
                  icon: <Icon component={BusinessInfoIcon} />,
                };
              }
              if (child.name === '承运平台') {
                return {
                  ...child,
                  icon: <Icon component={CarrierPlatformIcon} />,
                };
              }
              return child;
            });
            return {
              ...item,
              children,
              icon: <Icon component={BusinessManagementIcon} />,
            };
          }
          default:
            return item;
        }
      });
    },
  };
};
